import { FC, useCallback, useEffect } from 'react';
import { Style } from '@capacitor/status-bar';

import { useBusinessLayer } from '@mopla/business-logic';
import {
	Footer,
	IUserPersonalDetails,
	MainWithFooterTemplate,
	PersonalDetailsFormV2,
	useStatusBarStyleSync,
} from '@mopla/ui';
import { ContentWrapper } from '@mopla/ui/layouts/WelcomeScreen';

import { pushPersonalDetailsCompletedEvent } from '../../../../../app/userTracking/events';

export const PersonalDetailsFlow: FC = () => {
	const { push, pop } = useStatusBarStyleSync();
	const { api } = useBusinessLayer();

	useEffect(() => {
		push({
			title: 'ForgotPasswordFlow',
			style: Style.Light,
		});

		return () => {
			pop();
		};
	}, [push, pop]);

	const onEditUser = useCallback(
		(personalDetails: IUserPersonalDetails) => {
			pushPersonalDetailsCompletedEvent();
			return api.post('/api/command/addPassengerDetails', personalDetails);
		},
		[api]
	);

	return (
		<PersonalDetailsFormV2
			onEdit={onEditUser}
			render={({ content, footer }) => (
				<MainWithFooterTemplate
					content={<ContentWrapper>{content}</ContentWrapper>}
					footer={<Footer>{footer}</Footer>}
				/>
			)}
		/>
	);
};
